import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/more.svg'
import _imports_1 from '@/assets/icons/thumbs-up-gray.svg'
import _imports_2 from '@/assets/icons/edit.svg'
import _imports_3 from '@/assets/icons/delete.svg'


const _hoisted_1 = {
  key: 0,
  class: "w-1/12"
}
const _hoisted_2 = { class: "w-full lg:w-1/12 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary lg:text-gray-500 font-semibold lg:font-normal" }, "Company", -1)
const _hoisted_4 = { class: "capitalize" }
const _hoisted_5 = { class: "w-full lg:w-2/12 flex flex-col items-center justify-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary lg:text-gray-500 font-semibold lg:font-normal" }, "Title", -1)
const _hoisted_7 = { class: "capitalize text-center" }
const _hoisted_8 = { class: "w-full lg:w-2/12 flex flex-col items-center justify-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary lg:text-gray-500 font-semibold lg:font-normal" }, "Category", -1)
const _hoisted_10 = { class: "capitalize" }
const _hoisted_11 = { class: "w-full lg:w-2/12 flex flex-col items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary lg:text-gray-500 font-semibold lg:font-normal" }, "Requested on", -1)
const _hoisted_13 = { class: "w-full lg:w-2/12 flex flex-col items-center justify-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary lg:text-gray-500 font-semibold lg:font-normal" }, " Amount ", -1)
const _hoisted_15 = { class: "uppercase" }
const _hoisted_16 = {
  key: 1,
  class: "w-2/12 flex flex-row items-center justify-end"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "capitalize"
}
const _hoisted_19 = {
  key: 2,
  class: "flex flex-row items-center"
}
const _hoisted_20 = { class: "relative flex flex-row ml-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-2 h-3"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  ref: "dropdown",
  class: "absolute flex flex-col text-black bg-white right-0 mr-10 mt-4 rounded-2xl shadow hover:shadow-md p-2 w-72 z-50"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Decide")
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Edit")
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Delete")
], -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 3 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", { class: "ml-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "    ")
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 4,
  class: "w-full lg:w-2/12 flex flex-row items-center justify-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_ModalDecision = _resolveComponent("ModalDecision")!
  const _component_ModalExpenses = _resolveComponent("ModalExpenses")!
  const _component_ModalReason = _resolveComponent("ModalReason")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "flex flex-col lg:flex-row items-center bg-white rounded-2xl shadow p-8 mb-4",
      onMouseover: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hover = true && _ctx.reimbursement.status !== 'pending')),
      onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hover = false && _ctx.reimbursement.status !== 'pending'))
    }, [
      (_ctx.reimbursement.user)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_UserCard, {
              firstName: _ctx.reimbursement.user.first_name,
              lastName: _ctx.reimbursement.user.last_name,
              showName: false
            }, null, 8, ["firstName", "lastName"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.reimbursement.company.visible_name), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.reimbursement.title), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.reimbursement.detail.replaceAll("_", " ")), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", null, [
          _createVNode(_component_DateFormatter, {
            date: _ctx.reimbursement.created_at
          }, null, 8, ["date"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", null, [
          _createTextVNode("$" + _toDisplayString((_ctx.reimbursement.original_amount / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })) + " ", 1),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.reimbursement.currency), 1)
        ])
      ]),
      (!_ctx.hover)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass(["w-3 h-3 rounded-full mr-3", {
          'bg-orange-500': _ctx.reimbursement.status === 'pending',
          'bg-red-500': _ctx.reimbursement.status === 'denied',
          'bg-blue-800': _ctx.reimbursement.status === 'approved',
          'bg-green-500': _ctx.reimbursement.status === 'paid',
        }])
            }, null, 2),
            (_ctx.reimbursement.status === 'pending')
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Pending approval "))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.reimbursement.status), 1))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.hover && _ctx.reimbursement.status === 'pending')
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDropdown(_ctx.reimbursement.id))),
                class: "px-2"
              }, _hoisted_22),
              (_ctx.reimbursement.id === _ctx.openDropdown)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {
              _ctx.openDecision = true;
              _ctx.showDropdown('');
            }),
                      class: "hover:bg-background p-4 rounded"
                    }, _hoisted_25),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => {
              _ctx.openModal = true;
              _ctx.showDropdown('');
            }),
                      class: "hover:bg-background p-4 rounded"
                    }, _hoisted_27),
                    _createElementVNode("button", {
                      class: "hover:bg-background p-4 rounded",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {
              _ctx.deleteReimbursement(_ctx.reimbursement.id);
              _ctx.showDropdown('');
            })
                    }, _hoisted_29)
                  ], 512))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32)),
      (_ctx.hover)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("button", {
              class: "bg-primary text-white rounded-full py-2 px-8 hover:bg-primary-dark",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openReason = true))
            }, " View reason ")
          ]))
        : _createCommentVNode("", true)
    ], 32),
    _createVNode(_component_ModalDecision, {
      openDecision: _ctx.openDecision,
      "onUpdate:openDecision": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.openDecision) = $event)),
      reimbursement: _ctx.reimbursement
    }, null, 8, ["openDecision", "reimbursement"]),
    _createVNode(_component_ModalExpenses, {
      openModal: _ctx.openModal,
      "onUpdate:openModal": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.openModal) = $event)),
      reimbursement: _ctx.reimbursement
    }, null, 8, ["openModal", "reimbursement"]),
    _createVNode(_component_ModalReason, {
      openReason: _ctx.openReason,
      "onUpdate:openReason": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.openReason) = $event)),
      reimbursement: _ctx.reimbursement
    }, null, 8, ["openReason", "reimbursement"])
  ], 64))
}